// extracted by mini-css-extract-plugin
module.exports = {"item":"DropdownItem_item__3nb63"};